import React from 'react'

const AutomationOptionsAlarm = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className={className}>
    <path
      d="M24.4603 46.03C35.4453 46.03 44.3503 37.1249 44.3503 26.14C44.3503 15.1551 35.4453 6.25 24.4603 6.25C13.4754 6.25 4.57031 15.1551 4.57031 26.14C4.57031 37.1249 13.4754 46.03 24.4603 46.03Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M24.4492 9.93005V26.1401L32.6392 22.6601" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M33.2891 3.91996C34.8432 2.36951 36.9488 1.49878 39.144 1.49878C41.3393 1.49878 43.4449 2.36951 44.999 3.91996C46.5501 5.47577 47.4211 7.58306 47.4211 9.77996C47.4211 11.9769 46.5501 14.0841 44.999 15.64L33.2891 3.91996Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M3.9201 15.64C2.36904 14.0841 1.49805 11.9769 1.49805 9.77996C1.49805 7.58306 2.36904 5.47577 3.9201 3.91996C5.47422 2.36951 7.57983 1.49878 9.77509 1.49878C11.9703 1.49878 14.076 2.36951 15.6301 3.91996L3.9201 15.64Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M12.7498 42.02L6.50977 48.26" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M36.1699 42.02L42.4199 48.26" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
)

export default AutomationOptionsAlarm
